export const getGraphQLUrl = () => {
  return process.env.REACT_APP_KOVI_GRAPHQL_URL || '';
};

export const getWebchatGraphQLUrl = () => {
  return process.env.LIB_WEBCHAT_GRAPHQL_URL || '';
};
